import { Button as ArcoButton, type ButtonProps as ArcoButtonProps } from '@arco-design/web-react';
import clsx from 'clsx';

import './Button.css';

type ButtonProps = Omit<ArcoButtonProps, 'type'> & {
  variant?: 'primary' | 'primaryPurple' | 'secondary' | 'outline' | 'text';
};

export const Button = (props: ButtonProps) => {
  const { variant, ...rest } = props;

  if (variant === 'primaryPurple') {
    return (
      <ArcoButton
        {...rest}
        type="primary"
        //
        className={clsx('primary-purple-button', rest.className)}
      />
    );
  }

  return <ArcoButton {...rest} type={variant} />;
};
